'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fade = exports.Touchable = exports.ActionMessage = exports.SvgActionIcon = exports.SvgInfoIcon = exports.Message = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 100%;\n  z-index: 1;\n  padding-left: 16px;\n  padding-right: 16px;\n  position: fixed;\n  bottom: 0px;\n  left: 0px;\n'], ['\n  width: 100%;\n  z-index: 1;\n  padding-left: 16px;\n  padding-right: 16px;\n  position: fixed;\n  bottom: 0px;\n  left: 0px;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n'], ['\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  margin-right: 16px;\n'], ['\n  margin-right: 16px;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  margin-left: 16px;\n'], ['\n  margin-left: 16px;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  padding-bottom: 16px;\n'], ['\n  padding-bottom: 16px;\n']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n  max-width: 568px;\n  display: flex;\n  flex-direction: row;\n  height: 48px;\n  border-radius: 4px;\n  background-color: #4a4a4a;\n  align-items: center;\n  padding: 14px 24px;\n  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 1px 18px 0 rgba(0, 0, 0, 0.12);\n  cursor: pointer;\n'], ['\n  max-width: 568px;\n  display: flex;\n  flex-direction: row;\n  height: 48px;\n  border-radius: 4px;\n  background-color: #4a4a4a;\n  align-items: center;\n  padding: 14px 24px;\n  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 1px 18px 0 rgba(0, 0, 0, 0.12);\n  cursor: pointer;\n']),
    _templateObject7 = (0, _taggedTemplateLiteral3.default)(['\n  0% {\n    opacity: 0;\n    transform: translate(0, 100%);\n  }\n  100% {\n    opacity: 1;\n    transform: none;\n  }\n'], ['\n  0% {\n    opacity: 0;\n    transform: translate(0, 100%);\n  }\n  100% {\n    opacity: 1;\n    transform: none;\n  }\n']),
    _templateObject8 = (0, _taggedTemplateLiteral3.default)(['\n  animation: 0.5s ', ';\n'], ['\n  animation: 0.5s ', ';\n']),
    _templateObject9 = (0, _taggedTemplateLiteral3.default)(['\n  0% {\n    opacity: 1;\n    transform: none;\n  }\n  100% {\n    opacity: 0;\n    transform: translate(0, 100%);\n  }\n'], ['\n  0% {\n    opacity: 1;\n    transform: none;\n  }\n  100% {\n    opacity: 0;\n    transform: translate(0, 100%);\n  }\n']),
    _templateObject10 = (0, _taggedTemplateLiteral3.default)(['\n  animation: 0.5s ', ';\n  animation-fill-mode: forwards;\n'], ['\n  animation: 0.5s ', ';\n  animation-fill-mode: forwards;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Text = require('../../fundamentals/Text');

var _Text2 = _interopRequireDefault(_Text);

var _Svg = require('../../atoms/Svg');

var _Svg2 = _interopRequireDefault(_Svg);

var _View = require('../../atoms/View');

var _View2 = _interopRequireDefault(_View);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = (0, _styledComponents2.default)(_View2.default)(_templateObject);

var Message = exports.Message = (0, _styledComponents2.default)(function (props) {
  return _react2.default.createElement(_Text2.default, (0, _extends3.default)({
    tag: 'p',
    weight: 'semiBold',
    size: 'body2',
    color: 'white'
  }, props));
})(_templateObject2);

var SvgInfoIcon = exports.SvgInfoIcon = (0, _styledComponents2.default)(_Svg2.default)(_templateObject3);

var SvgActionIcon = exports.SvgActionIcon = (0, _styledComponents2.default)(_Svg2.default)(_templateObject4);

var ActionMessage = exports.ActionMessage = (0, _styledComponents2.default)(function (props) {
  return _react2.default.createElement(_Text2.default, (0, _extends3.default)({
    weight: 'semiBold',
    size: 'body2',
    color: 'purpleMedium'
  }, props));
})(_templateObject4);

var ContentWrapper = (0, _styledComponents2.default)(_View2.default)(_templateObject5);

var Content = (0, _styledComponents2.default)(_View2.default)(_templateObject6);

var Touchable = exports.Touchable = function Touchable(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick;
  return _react2.default.createElement(
    ContentWrapper,
    null,
    _react2.default.createElement(
      Content,
      { onClick: onClick },
      children
    )
  );
};

Touchable.propTypes = {
  onClick: _propTypes2.default.func.isRequired
};

var fadeUpAnimation = (0, _styledComponents.keyframes)(_templateObject7);

var FadeUp = (0, _styledComponents2.default)(_View2.default)(_templateObject8, fadeUpAnimation);

var fadeDownAnimation = (0, _styledComponents.keyframes)(_templateObject9);

var FadeDown = (0, _styledComponents2.default)(_View2.default)(_templateObject10, fadeDownAnimation);

var Fade = exports.Fade = function (_React$Component) {
  (0, _inherits3.default)(Fade, _React$Component);

  function Fade(props) {
    (0, _classCallCheck3.default)(this, Fade);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Fade.__proto__ || (0, _getPrototypeOf2.default)(Fade)).call(this, props));

    _this.state = {
      unmount: !props.show
    };
    return _this;
  }

  (0, _createClass3.default)(Fade, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      var previousShow = prevProps.show;
      var show = this.props.show;

      if (previousShow && !show) {
        setTimeout(function () {
          return _this2.setState({ unmount: true });
        }, 1000);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          show = _props.show,
          children = _props.children;
      var unmount = this.state.unmount;

      if (unmount) {
        return null;
      }

      if (show) {
        return _react2.default.createElement(
          Wrapper,
          null,
          _react2.default.createElement(
            FadeUp,
            null,
            children
          )
        );
      }

      return _react2.default.createElement(
        Wrapper,
        null,
        _react2.default.createElement(
          FadeDown,
          null,
          children
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      if (props.show && state.unmount) {
        return { unmount: false };
      }
      return null;
    }
  }]);
  return Fade;
}(_react2.default.Component);

Fade.propTypes = {
  show: _propTypes2.default.bool
};